import { Button, useDisclosure } from "@heroui/react";
import type { Table as TanstackTable } from "@tanstack/react-table";
import { Columns3 } from "lucide-react";

import ColumnSettingsDialog from "./ColumnSettingsDialog";
import { orderedLeafColumns } from "./columnOrder";

/**
 * 「表示列」ボタン＋設定ダイアログ（[[ColumnSettingsDialog]]）。
 *
 * ツールバーに表示列ボタンを置く画面で使う。ケバブメニューから開く画面は
 * ダイアログを直接使う。
 */
export default function ColumnSettingsButton<T>({
  table,
  onReset,
}: {
  table: TanstackTable<T>;
  onReset: () => void;
}) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const hiddenCount = orderedLeafColumns(table).filter((c) => !c.getIsVisible()).length;

  return (
    <>
      <Button
        radius="full"
        variant={hiddenCount > 0 ? "solid" : "bordered"}
        color={hiddenCount > 0 ? "primary" : "default"}
        startContent={<Columns3 size={16} />}
        onPress={onOpen}
      >
        {hiddenCount > 0 ? `表示列（${hiddenCount} 列非表示）` : "表示列"}
      </Button>

      <ColumnSettingsDialog
        isOpen={isOpen}
        onClose={onClose}
        table={table}
        onReset={onReset}
      />
    </>
  );
}
